
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as build4RGeLIkwj_Ng_ojbQRbqmcb3O4akGb7T5MeWTcjr4tgMeta } from "/opt/apps/transkribus_app_beta/app/pages/build.vue?macro=true";
import { default as guide98HytP4F1dRfczOGjU6Iv83p10bZcLRElT4v0Y4kBncMeta } from "/opt/apps/transkribus_app_beta/app/pages/guide.vue?macro=true";
import { default as index_UzhZlJzvfNTTb0mm0dgcl4m1ZTYtn66XbYa2_3xqRwMeta } from "/opt/apps/transkribus_app_beta/app/pages/index.vue?macro=true";
import { default as login2QZ8EcVSP6m65TW5s67ovS9XpO3EOtBMuzdJpm_zuHoMeta } from "/opt/apps/transkribus_app_beta/app/pages/login.vue?macro=true";
import { default as changelog1MTOE4Jt2iOsSwXgogEbn_IoFI8w6TP5ZkzgYZDwDrkMeta } from "/opt/apps/transkribus_app_beta/app/pages/changelog.vue?macro=true";
import { default as mapoKD0DsaGz1mwtXSbVhWgXAfsAehS36hF1ofw1NYoYUoMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/map.vue?macro=true";
import { default as index3_bvnAdpZeSTm_3c8r2rZ_iOeTv_zw6rvh8g59CgeMIMeta } from "/opt/apps/transkribus_app_beta/app/pages/jobs/index.vue?macro=true";
import { default as indexbwgcKJEn82Rup_OWL8MXmBweFUGqdlweH9gnkiPwMB4Meta } from "/opt/apps/transkribus_app_beta/app/pages/learn/index.vue?macro=true";
import { default as indexZNhN5_uPIXABIrwVOsnseY90XEJaXEh3qQI5nBpQWyoMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/index.vue?macro=true";
import { default as index1cj_Y9NXL3eoa2KPoiqkLoHBlIsFAz8kDDml030SabYMeta } from "/opt/apps/transkribus_app_beta/app/pages/usage/index.vue?macro=true";
import { default as indexLth5LZRs6ygHtXdcvk80oA5Um2ssOaLDARoPmvs3KZEMeta } from "/opt/apps/transkribus_app_beta/app/pages/models/index.vue?macro=true";
import { default as indexP4MioH0qiLBXXYKm_5GKYXnHHlCdcqokAaM_z1lIKbMMeta } from "/opt/apps/transkribus_app_beta/app/pages/search/index.vue?macro=true";
import { default as createUyNf9uODlo_CdkP076agZAyCIDVijvnbYDmS4tBa39EMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/create.vue?macro=true";
import { default as index6wUVX94JWIYEhtiRlBm_j8DkIgyFXsu81JB_fnE0wFoMeta } from "/opt/apps/transkribus_app_beta/app/pages/upload/index.vue?macro=true";
import { default as index_hjOXThWV4aAXNuYJYRl5eXRGSWE7zNSCEEM5OYwvq4Meta } from "/opt/apps/transkribus_app_beta/app/pages/version/index.vue?macro=true";
import { default as index4xSMWdQ9Z24L6t_caFo0Nx_yuHvNk1l7C9uoQaXRf1cMeta } from "/opt/apps/transkribus_app_beta/app/pages/welcome/index.vue?macro=true";
import { default as indextIRoXcE_M26brlesef9GwTa8iUo3QRrtveqPha9OU54Meta } from "/opt/apps/transkribus_app_beta/app/pages/data-lab/index.vue?macro=true";
import { default as indextsfmBs1Mcaw9yc3suGkGfMqkI0go2JXDhvtTBQk87FUMeta } from "/opt/apps/transkribus_app_beta/app/pages/datasets/index.vue?macro=true";
import { default as index7_UBlV5iCMQdGlsh6ld__9ZCpPUQ5krTsvCUHmnMndgMeta } from "/opt/apps/transkribus_app_beta/app/pages/projects/index.vue?macro=true";
import { default as index6vjD8FEr4ZWGaNk9xB0Gc60LdvArGPL55WipjJvy9cQMeta } from "/opt/apps/transkribus_app_beta/app/pages/my-models/index.vue?macro=true";
import { default as index5m5DVPLzDxLR9HIHAuaLBQ8nGWaeQAOPOiDQyucA9NQMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection/index.vue?macro=true";
import { default as index_1pQfbIIySeaUYUcc8Sta9GcBDwFKFXD_wVYB7VM7RwMeta } from "/opt/apps/transkribus_app_beta/app/pages/invitations/index.vue?macro=true";
import { default as indextaito1Vkdupf87_KuXCu_DZGbHN_rcOJmO3raG11R7gMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/index.vue?macro=true";
import { default as indexOpTmgqn7X2pFZ9YYQ_pOtbS7lD5Tupru9iS5ebzZzKYMeta } from "/opt/apps/transkribus_app_beta/app/pages/activity/all/index.vue?macro=true";
import { default as admin_45slugsDy_Qa6Qum5brcSs4bCvGlbZNInVaE0e5AeNKrcpakLoMeta } from "/opt/apps/transkribus_app_beta/app/pages/models/admin-slugs.vue?macro=true";
import { default as indextDHn6T2bl56HiYXcvLk2jaK4rdy37vP8UhoUu3Dr6fAMeta } from "/opt/apps/transkribus_app_beta/app/pages/share/[hash]/index.vue?macro=true";
import { default as overviewTBbveucu64PX90VnfVoD4ipBIb44oXowqN0f_q0WXhsMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection/overview.vue?macro=true";
import { default as indexCqLO1Etz8SzBNCWdxIUdWxyD_6DM4OKJzEG7ozuxowEMeta } from "/opt/apps/transkribus_app_beta/app/pages/datasets/[id]/index.vue?macro=true";
import { default as index7YH9T3225RoPkZAitGkUvCQrBv6QDPhSfksxCa1_5xgMeta } from "/opt/apps/transkribus_app_beta/app/pages/models/public/index.vue?macro=true";
import { default as indexcx3iSPp614Ys5lv2o02yP0W1i6QbCNCHv6nVFYJ8Py8Meta } from "/opt/apps/transkribus_app_beta/app/pages/notifications/index.vue?macro=true";
import { default as indexPk8xdPZjS_3umT_XtAtgVlA2__WEd_qUT4TYNxlMosAMeta } from "/opt/apps/transkribus_app_beta/app/pages/projects/[id]/index.vue?macro=true";
import { default as indexKvD7f_Bt2qYKqteVEynb0Lz_IKYlxgx0ubScpPMEn7AMeta } from "/opt/apps/transkribus_app_beta/app/pages/public-models/index.vue?macro=true";
import { default as indexW_PBM7jiQqIZxUi_M7HGREtUlqCwJt0OFfHS3vWNy4oMeta } from "/opt/apps/transkribus_app_beta/app/pages/user-settings/index.vue?macro=true";
import { default as indexxZ2LSWz_578_YzrybNx4uRAqz_ofc9DhQxzu_7LZGlkMeta } from "/opt/apps/transkribus_app_beta/app/pages/data-lab/train/index.vue?macro=true";
import { default as indexSMVkqbJALZ6ajKcTMtv0xGr5jwTpI3PjO0_uFkUDfowMeta } from "/opt/apps/transkribus_app_beta/app/pages/activity/hermes/index.vue?macro=true";
import { default as indexJnny6QhitnWQRuxPjv62o1248n_FxR6rR_zDVbZoTVIMeta } from "/opt/apps/transkribus_app_beta/app/pages/datasets/create/index.vue?macro=true";
import { default as index7653sRIHKedUEhs7f0Y4Ki2zfIIsgmH0p3J9vAu4tQAMeta } from "/opt/apps/transkribus_app_beta/app/pages/projects/create/index.vue?macro=true";
import { default as indexJlYcvDxTmyo3DHF1flMDD2Hnx_9zX1pqoJXF7PCPPOQMeta } from "/opt/apps/transkribus_app_beta/app/pages/quality-control/index.vue?macro=true";
import { default as index83xZC933boluxQuvbxIdLWR80T6TJOCA0kxrgMfokn0Meta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/tags/index.vue?macro=true";
import { default as indexUZMg_7aZNN38Ndlm1d8ZSQu_nnWwxOjie_VnIqP23AEMeta } from "/opt/apps/transkribus_app_beta/app/pages/activity/advanced/index.vue?macro=true";
import { default as indexTI7kBiC2E_kfd0w6PwgCbVwzeOf3Ey2vfPuDfHN5UckMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/about/index.vue?macro=true";
import { default as _91_46_46_46path_932fDBnEjb48jUZ0Y3rR1Dv3KaOdQn3h_mlco0Arto8VQMeta } from "/opt/apps/transkribus_app_beta/app/pages/[locale]/sites/[...path].vue?macro=true";
import { default as indexj_ATe47sXYSNFE_BNMjrWtUpQX5hYLD6o2NRmFoUmk4Meta } from "/opt/apps/transkribus_app_beta/app/pages/datasets/[id]/data/index.vue?macro=true";
import { default as indexLHBsikfqhoLFJFteLCyUacuqlOLJPhKQ52VfRffv2LMMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/browse/index.vue?macro=true";
import { default as index_YyrLoOmR1HnI5Y_YLIKR6tkNtIgmGTLc_E_7W0x4MQMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/search/index.vue?macro=true";
import { default as indexpMVMIw_2cOrYw4rh87q5sn4zKSzeIiRvKjWrtff68mkMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection-settings/index.vue?macro=true";
import { default as index4X1NX_h6b8RRrWdjhaAEMW1YndJTHXkJ5kmRcHfGjvYMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/imprint/index.vue?macro=true";
import { default as indexedezvDpR0eCF_ZJ_vXcWzkLRvnacfk_n30C8d3MGK08Meta } from "/opt/apps/transkribus_app_beta/app/pages/activity/recognition/index.vue?macro=true";
import { default as indexfMg7nCwCZzdaMwUrD8fxWvByBsGooFFU5DvYnicB_iwMeta } from "/opt/apps/transkribus_app_beta/app/pages/activity/up-download/index.vue?macro=true";
import { default as index3AzhNhcWfw0MsF9EYH3qdXVa6C6_AERlZuJt0R41NmoMeta } from "/opt/apps/transkribus_app_beta/app/pages/datasets/[id]/manage/index.vue?macro=true";
import { default as indexl6B5VuHuCjxNhZdB50tSyw44aopPUz1Oe3s25ZB_mc4Meta } from "/opt/apps/transkribus_app_beta/app/pages/projects/[id]/manage/index.vue?macro=true";
import { default as indexnlJGgceaQ2QJqg_VCnlBrfFAE1LRo94L79DmQaYytHcMeta } from "/opt/apps/transkribus_app_beta/app/pages/invitations/[inviteid]/index.vue?macro=true";
import { default as indexwbpUMyW5hDbZOvg708S327FX03pq5tdcTch3XFFfiO4Meta } from "/opt/apps/transkribus_app_beta/app/pages/models/[type]/[modelId]/index.vue?macro=true";
import { default as indexyg1l_bupG_8XI36fUB9pvfinr7Ropva8fqjr40ytuPYMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/doc/[docid]/index.vue?macro=true";
import { default as indexPpSPNiFb_S_q9QW9onNDztm_iQVzidWCU1NeypRmJ6QMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/index.vue?macro=true";
import { default as indexpazB5RhdXVyVPicU2VZMRzYs_mO_sXxKuEzVDq1e8AkMeta } from "/opt/apps/transkribus_app_beta/app/pages/models/[type]/[modelId]/modify/index.vue?macro=true";
import { default as indexNMILB0qOO17uRTQVuO9eAICcK5xbS1JaupEivImleB0Meta } from "/opt/apps/transkribus_app_beta/app/pages/models/public/[type]/[modelId]/index.vue?macro=true";
import { default as index2Cwh8_TT5ioPW5zk2sSUbiRUeRMOobCQuharr3rVNjcMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/doc/[docid]/detail/index.vue?macro=true";
import { default as index1fNM89lBWo7eDo0fyYGFAmU31DUEehlHLjeHoJupTvYMeta } from "/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/index.vue?macro=true";
import { default as indexngcHip2V1BwMCUlN91BzgqsWHq6etxRzedOJt9re6EsMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/content/[contentName]/index.vue?macro=true";
import { default as indexZ77Wdt1gki4Hjkmm3roqWxCmjBV_gpBh4hff8y16KucMeta } from "/opt/apps/transkribus_app_beta/app/pages/models/[type]/[modelId]/train-data/index.vue?macro=true";
import { default as indexo1EGjsBmzqly9vB2xPvpl4ZLuane4ewVZvyonIpCOhIMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/index.vue?macro=true";
import { default as indexl3hYdhgM8sYiWkw7RFIxsmh7jIKx_Mw5j9_sssrmzKQMeta } from "/opt/apps/transkribus_app_beta/app/pages/sites/[url]/doc/[docid]/detail/[pageid]/index.vue?macro=true";
import { default as index6_tKR_9z25lsd9QhZAJ9ixfVtoYn52o6eSJqolpgVbgMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/edit/index.vue?macro=true";
import { default as index4SQuRMUB30t_VE8lgooIVMaHdquQJF6NDHO84xSX9UoMeta } from "/opt/apps/transkribus_app_beta/app/pages/usage/manage-organisation/[organisationid]/index.vue?macro=true";
import { default as indexQJH13uP4lPS7X2jPY21Ks3KGUEbAZdo59nB88FcmINEMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/edit/[pageid]/index.vue?macro=true";
import { default as index60K3tLvRrsPU1uqXyHyT5L3RDGbpF_AM6K1gIj_JGgwMeta } from "/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/detail/[pageid]/index.vue?macro=true";
import { default as indexjN2EJS4EdD4CBpNOqVwa99cREOUpAaArJC56eINlPBAMeta } from "/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/index.vue?macro=true";
import { default as indexW5gJ7mPH1UvyKbgIG7m6h07h9tsELH2BlIDAseh7GtEMeta } from "/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/results/index.vue?macro=true";
import { default as indexTP_8bO53shxqcW9s7GVOaac6YzlW4WhruXcAv1W5HI0Meta } from "/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/page/[pageid]/index.vue?macro=true";
import { default as component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlgMeta } from "/opt/apps/transkribus_app_beta/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlg } from "/opt/apps/transkribus_app_beta/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "build",
    path: "/build",
    meta: { ...(build4RGeLIkwj_Ng_ojbQRbqmcb3O4akGb7T5MeWTcjr4tgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/build.vue")
  },
  {
    name: "guide",
    path: "/guide",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/guide.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index_UzhZlJzvfNTTb0mm0dgcl4m1ZTYtn66XbYa2_3xqRwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(login2QZ8EcVSP6m65TW5s67ovS9XpO3EOtBMuzdJpm_zuHoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/login.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    meta: { ...(changelog1MTOE4Jt2iOsSwXgogEbn_IoFI8w6TP5ZkzgYZDwDrkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/changelog.vue")
  },
  {
    name: "sites-map",
    path: "/sites/map",
    meta: { ...(mapoKD0DsaGz1mwtXSbVhWgXAfsAehS36hF1ofw1NYoYUoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/map.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    meta: { ...(index3_bvnAdpZeSTm_3c8r2rZ_iOeTv_zw6rvh8g59CgeMIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/jobs/index.vue")
  },
  {
    name: "learn",
    path: "/learn",
    meta: { ...(indexbwgcKJEn82Rup_OWL8MXmBweFUGqdlweH9gnkiPwMB4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/learn/index.vue")
  },
  {
    name: "sites",
    path: "/sites",
    meta: { ...(indexZNhN5_uPIXABIrwVOsnseY90XEJaXEh3qQI5nBpQWyoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/index.vue")
  },
  {
    name: "usage",
    path: "/usage",
    meta: { ...(index1cj_Y9NXL3eoa2KPoiqkLoHBlIsFAz8kDDml030SabYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/usage/index.vue")
  },
  {
    name: "models",
    path: "/models",
    meta: { ...(indexLth5LZRs6ygHtXdcvk80oA5Um2ssOaLDARoPmvs3KZEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/models/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: { ...(indexP4MioH0qiLBXXYKm_5GKYXnHHlCdcqokAaM_z1lIKbMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/search/index.vue")
  },
  {
    name: "sites-create",
    path: "/sites/create",
    meta: { ...(createUyNf9uODlo_CdkP076agZAyCIDVijvnbYDmS4tBa39EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/create.vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: { ...(index6wUVX94JWIYEhtiRlBm_j8DkIgyFXsu81JB_fnE0wFoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/upload/index.vue")
  },
  {
    name: "version",
    path: "/version",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/version/index.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: {"middleware":"auth"},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/welcome/index.vue")
  },
  {
    name: "data-lab",
    path: "/data-lab",
    meta: { ...(indextIRoXcE_M26brlesef9GwTa8iUo3QRrtveqPha9OU54Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/data-lab/index.vue")
  },
  {
    name: "datasets",
    path: "/datasets",
    meta: { ...(indextsfmBs1Mcaw9yc3suGkGfMqkI0go2JXDhvtTBQk87FUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/datasets/index.vue")
  },
  {
    name: "projects",
    path: "/projects",
    meta: { ...(index7_UBlV5iCMQdGlsh6ld__9ZCpPUQ5krTsvCUHmnMndgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/projects/index.vue")
  },
  {
    name: "my-models",
    path: "/my-models",
    meta: { ...(index6vjD8FEr4ZWGaNk9xB0Gc60LdvArGPL55WipjJvy9cQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/my-models/index.vue")
  },
  {
    name: "collection",
    path: "/collection",
    meta: { ...(index5m5DVPLzDxLR9HIHAuaLBQ8nGWaeQAOPOiDQyucA9NQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection/index.vue")
  },
  {
    name: "invitations",
    path: "/invitations",
    meta: { ...(index_1pQfbIIySeaUYUcc8Sta9GcBDwFKFXD_wVYB7VM7RwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/invitations/index.vue")
  },
  {
    name: "sites-url",
    path: "/sites/:url()",
    meta: indextaito1Vkdupf87_KuXCu_DZGbHN_rcOJmO3raG11R7gMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/index.vue")
  },
  {
    name: "activity-all",
    path: "/activity/all",
    meta: { ...(indexOpTmgqn7X2pFZ9YYQ_pOtbS7lD5Tupru9iS5ebzZzKYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/activity/all/index.vue")
  },
  {
    name: "models-admin-slugs",
    path: "/models/admin-slugs",
    meta: { ...(admin_45slugsDy_Qa6Qum5brcSs4bCvGlbZNInVaE0e5AeNKrcpakLoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/models/admin-slugs.vue")
  },
  {
    name: "share-hash",
    path: "/share/:hash()",
    meta: indextDHn6T2bl56HiYXcvLk2jaK4rdy37vP8UhoUu3Dr6fAMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/share/[hash]/index.vue")
  },
  {
    name: "collection-overview",
    path: "/collection/overview",
    meta: { ...(overviewTBbveucu64PX90VnfVoD4ipBIb44oXowqN0f_q0WXhsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection/overview.vue")
  },
  {
    name: "datasets-id",
    path: "/datasets/:id()",
    meta: { ...(indexCqLO1Etz8SzBNCWdxIUdWxyD_6DM4OKJzEG7ozuxowEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/datasets/[id]/index.vue")
  },
  {
    name: "models-public",
    path: "/models/public",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/models/public/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: { ...(indexcx3iSPp614Ys5lv2o02yP0W1i6QbCNCHv6nVFYJ8Py8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/notifications/index.vue")
  },
  {
    name: "projects-id",
    path: "/projects/:id()",
    meta: { ...(indexPk8xdPZjS_3umT_XtAtgVlA2__WEd_qUT4TYNxlMosAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/projects/[id]/index.vue")
  },
  {
    name: "public-models",
    path: "/public-models",
    meta: indexKvD7f_Bt2qYKqteVEynb0Lz_IKYlxgx0ubScpPMEn7AMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/public-models/index.vue")
  },
  {
    name: "user-settings",
    path: "/user-settings",
    meta: { ...(indexW_PBM7jiQqIZxUi_M7HGREtUlqCwJt0OFfHS3vWNy4oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/user-settings/index.vue")
  },
  {
    name: "data-lab-train",
    path: "/data-lab/train",
    meta: { ...(indexxZ2LSWz_578_YzrybNx4uRAqz_ofc9DhQxzu_7LZGlkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/data-lab/train/index.vue")
  },
  {
    name: "activity-hermes",
    path: "/activity/hermes",
    meta: { ...(indexSMVkqbJALZ6ajKcTMtv0xGr5jwTpI3PjO0_uFkUDfowMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/activity/hermes/index.vue")
  },
  {
    name: "datasets-create",
    path: "/datasets/create",
    meta: { ...(indexJnny6QhitnWQRuxPjv62o1248n_FxR6rR_zDVbZoTVIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/datasets/create/index.vue")
  },
  {
    name: "projects-create",
    path: "/projects/create",
    meta: { ...(index7653sRIHKedUEhs7f0Y4Ki2zfIIsgmH0p3J9vAu4tQAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/projects/create/index.vue")
  },
  {
    name: "quality-control",
    path: "/quality-control",
    meta: { ...(indexJlYcvDxTmyo3DHF1flMDD2Hnx_9zX1pqoJXF7PCPPOQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/quality-control/index.vue")
  },
  {
    name: "sites-url-tags",
    path: "/sites/:url()/tags",
    meta: index83xZC933boluxQuvbxIdLWR80T6TJOCA0kxrgMfokn0Meta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/tags/index.vue")
  },
  {
    name: "activity-advanced",
    path: "/activity/advanced",
    meta: { ...(indexUZMg_7aZNN38Ndlm1d8ZSQu_nnWwxOjie_VnIqP23AEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/activity/advanced/index.vue")
  },
  {
    name: "sites-url-about",
    path: "/sites/:url()/about",
    meta: indexTI7kBiC2E_kfd0w6PwgCbVwzeOf3Ey2vfPuDfHN5UckMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/about/index.vue")
  },
  {
    name: "locale-sites-path",
    path: "/:locale()/sites/:path(.*)*",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/[locale]/sites/[...path].vue")
  },
  {
    name: "datasets-id-data",
    path: "/datasets/:id()/data",
    meta: { ...(indexj_ATe47sXYSNFE_BNMjrWtUpQX5hYLD6o2NRmFoUmk4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/datasets/[id]/data/index.vue")
  },
  {
    name: "sites-url-browse",
    path: "/sites/:url()/browse",
    meta: indexLHBsikfqhoLFJFteLCyUacuqlOLJPhKQ52VfRffv2LMMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/browse/index.vue")
  },
  {
    name: "sites-url-search",
    path: "/sites/:url()/search",
    meta: index_YyrLoOmR1HnI5Y_YLIKR6tkNtIgmGTLc_E_7W0x4MQMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/search/index.vue")
  },
  {
    name: "collection-settings",
    path: "/collection-settings",
    meta: { ...(indexpMVMIw_2cOrYw4rh87q5sn4zKSzeIiRvKjWrtff68mkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection-settings/index.vue")
  },
  {
    name: "sites-url-imprint",
    path: "/sites/:url()/imprint",
    meta: index4X1NX_h6b8RRrWdjhaAEMW1YndJTHXkJ5kmRcHfGjvYMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/imprint/index.vue")
  },
  {
    name: "activity-recognition",
    path: "/activity/recognition",
    meta: { ...(indexedezvDpR0eCF_ZJ_vXcWzkLRvnacfk_n30C8d3MGK08Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/activity/recognition/index.vue")
  },
  {
    name: "activity-up-download",
    path: "/activity/up-download",
    meta: { ...(indexfMg7nCwCZzdaMwUrD8fxWvByBsGooFFU5DvYnicB_iwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/activity/up-download/index.vue")
  },
  {
    name: "datasets-id-manage",
    path: "/datasets/:id()/manage",
    meta: { ...(index3AzhNhcWfw0MsF9EYH3qdXVa6C6_AERlZuJt0R41NmoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/datasets/[id]/manage/index.vue")
  },
  {
    name: "projects-id-manage",
    path: "/projects/:id()/manage",
    meta: { ...(indexl6B5VuHuCjxNhZdB50tSyw44aopPUz1Oe3s25ZB_mc4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/projects/[id]/manage/index.vue")
  },
  {
    name: "invitations-inviteid",
    path: "/invitations/:inviteid()",
    meta: { ...(indexnlJGgceaQ2QJqg_VCnlBrfFAE1LRo94L79DmQaYytHcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/invitations/[inviteid]/index.vue")
  },
  {
    name: "models-type-modelId",
    path: "/models/:type()/:modelId()",
    meta: { ...(indexwbpUMyW5hDbZOvg708S327FX03pq5tdcTch3XFFfiO4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/models/[type]/[modelId]/index.vue")
  },
  {
    name: "sites-url-doc-docid",
    path: "/sites/:url()/doc/:docid()",
    meta: indexyg1l_bupG_8XI36fUB9pvfinr7Ropva8fqjr40ytuPYMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/doc/[docid]/index.vue")
  },
  {
    name: "collection-collectionid",
    path: "/collection/:collectionid()",
    meta: { ...(indexPpSPNiFb_S_q9QW9onNDztm_iQVzidWCU1NeypRmJ6QMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/index.vue")
  },
  {
    name: "models-type-modelId-modify",
    path: "/models/:type()/:modelId()/modify",
    meta: { ...(indexpazB5RhdXVyVPicU2VZMRzYs_mO_sXxKuEzVDq1e8AkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/models/[type]/[modelId]/modify/index.vue")
  },
  {
    name: "models-public-type-modelId",
    path: "/models/public/:type()/:modelId()",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/models/public/[type]/[modelId]/index.vue")
  },
  {
    name: "sites-url-doc-docid-detail",
    path: "/sites/:url()/doc/:docid()/detail",
    meta: index2Cwh8_TT5ioPW5zk2sSUbiRUeRMOobCQuharr3rVNjcMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/doc/[docid]/detail/index.vue")
  },
  {
    name: "quality-control-sample-sampleid",
    path: "/quality-control/sample/:sampleid()",
    meta: { ...(index1fNM89lBWo7eDo0fyYGFAmU31DUEehlHLjeHoJupTvYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/index.vue")
  },
  {
    name: "sites-url-content-contentName",
    path: "/sites/:url()/content/:contentName()",
    meta: indexngcHip2V1BwMCUlN91BzgqsWHq6etxRzedOJt9re6EsMeta || {},
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/content/[contentName]/index.vue")
  },
  {
    name: "models-type-modelId-train-data",
    path: "/models/:type()/:modelId()/train-data",
    meta: { ...(indexZ77Wdt1gki4Hjkmm3roqWxCmjBV_gpBh4hff8y16KucMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/models/[type]/[modelId]/train-data/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid",
    path: "/collection/:collectionid()/doc/:docid()",
    meta: { ...(indexo1EGjsBmzqly9vB2xPvpl4ZLuane4ewVZvyonIpCOhIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/index.vue")
  },
  {
    name: "sites-url-doc-docid-detail-pageid",
    path: "/sites/:url()/doc/:docid()/detail/:pageid()",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/sites/[url]/doc/[docid]/detail/[pageid]/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid-edit",
    path: "/collection/:collectionid()/doc/:docid()/edit",
    meta: { ...(index6_tKR_9z25lsd9QhZAJ9ixfVtoYn52o6eSJqolpgVbgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/edit/index.vue")
  },
  {
    name: "usage-manage-organisation-organisationid",
    path: "/usage/manage-organisation/:organisationid()",
    meta: { ...(index4SQuRMUB30t_VE8lgooIVMaHdquQJF6NDHO84xSX9UoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/usage/manage-organisation/[organisationid]/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid-edit-pageid",
    path: "/collection/:collectionid()/doc/:docid()/edit/:pageid()",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/edit/[pageid]/index.vue")
  },
  {
    name: "collection-collectionid-doc-docid-detail-pageid",
    path: "/collection/:collectionid()/doc/:docid()/detail/:pageid()",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/collection/[collectionid]/doc/[docid]/detail/[pageid]/index.vue")
  },
  {
    name: "quality-control-sample-sampleid-evaluation-evaluationid",
    path: "/quality-control/sample/:sampleid()/evaluation/:evaluationid()",
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/index.vue")
  },
  {
    name: "quality-control-sample-sampleid-evaluation-evaluationid-results",
    path: "/quality-control/sample/:sampleid()/evaluation/:evaluationid()/results",
    meta: { ...(indexW5gJ7mPH1UvyKbgIG7m6h07h9tsELH2BlIDAseh7GtEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/results/index.vue")
  },
  {
    name: "quality-control-sample-sampleid-evaluation-evaluationid-page-pageid",
    path: "/quality-control/sample/:sampleid()/evaluation/:evaluationid()/page/:pageid()",
    meta: { ...(indexTP_8bO53shxqcW9s7GVOaac6YzlW4WhruXcAv1W5HI0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/apps/transkribus_app_beta/app/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/page/[pageid]/index.vue")
  },
  {
    name: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlgMeta?.name,
    path: "/home",
    component: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlg
  },
  {
    name: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubg7XgebtTTJwtZGPtJUp19IKhMRXAEVvt5M9PXxJaHlg
  }
]